import React, {useEffect} from 'react'
import {Helmet} from 'react-helmet-async'
import {CopyInput} from '../../../components/library/copy'
import {Icon} from '../../../components/library/icon/icon'
import {EnvironmentNode} from '../../../environment'
import {useAnalytics} from '../../../lib/analytics/analytics'
import {getApiUrl} from '../../../lib/endpoints'
import {CLIENT_API_URL} from '../../../lib/env'
import {IconHeading, Section, SectionInfo} from '../components'

export const getApiHost = (environment: EnvironmentNode) =>
  `${getApiUrl(CLIENT_API_URL)(environment?.organisationId || '')}`

export const APIHost = ({environment}: {environment: EnvironmentNode}) => {
  const analytics = useAnalytics()

  useEffect(() => {
    analytics.track({
      event: 'Viewed sdk api host configuration',
      properties: {
        org_id: environment.organisationId,
        environment_id: environment.id,
        category: 'configuration>sdk>api-host'
      }
    })
  }, [analytics, environment])

  return (
    <Section>
      <Helmet>
        <title>SDK API Host</title>
      </Helmet>
      <header>
        <IconHeading>
          <Icon name="web" /> SDK API Host
        </IconHeading>
      </header>
      <SectionInfo>
        <p>Used to configure your SDK integration to interact with Atomic</p>
      </SectionInfo>
      <CopyInput size="large" value={getApiHost(environment)} />
    </Section>
  )
}
